import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown", "currentLocale"]

  connect() {
    // Fermer le dropdown quand on clique ailleurs
    document.addEventListener('click', this.closeOnClickOutside.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.closeOnClickOutside.bind(this))
  }

  toggle(event) {
    event.stopPropagation()
    this.dropdownTarget.classList.toggle('hidden')
  }

  select(event) {
    event.preventDefault()
    const locale = event.currentTarget.dataset.locale
    const currentPath = window.location.pathname
    const currentSearch = window.location.search

    // Remplacer la locale dans l'URL
    const newPath = currentPath.replace(/^\/(fr|en|es)/, `/${locale}`)

    // Rediriger vers la nouvelle URL (avec query params si présents)
    window.location.href = newPath + currentSearch
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.classList.add('hidden')
    }
  }
}
